import React from 'react'
import { ReactBarcode } from 'react-jsbarcode';


const Barcode = ({ orderId }) => {

    return <ReactBarcode
        value={String(orderId).trim()}
        renderer="svg"
        options={{
            format: 'code128',
            height: "50",
            width: "3",
            displayValue: true
        }}

    />;

}

export default Barcode